module.exports = __webpack_public_path__ + "static/media/btn-remove-photo.4a182d4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/btn-remove-photo.svg
// module id = 774
// module chunks = 0